module.exports = __webpack_public_path__ + "img/sprinkle-6.2de02191.jpg";